import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnswerBusinessService } from 'src/app/i2a/core/services/business/answer-business.service';
import { DismissStatus } from 'src/app/models/dismiss-status';
import { AlertFormBase } from '../alert-form-base';
import { Constants } from 'src/app/i2a/core/models/Constants';

@Component({
  selector: 'app-is-suspicious',
  templateUrl: './is-suspicious.component.html',
  styleUrls: ['./is-suspicious.component.scss']
})
export class IsSuspiciousComponent extends AlertFormBase implements OnInit, OnDestroy {
  private status = DismissStatus.IsSuspicious;

  constructor(
    private Constants: Constants,
    answerBusiness: AnswerBusinessService,
    route: ActivatedRoute,
    router: Router) {
    super(answerBusiness, route, router);
  }

}
